import CONSTANTS from '../../config';
import DrmConfiguration from '../drm/drmConfiguration';
import HttpUtils from '../../util/http_utils';
import {ErrorHandler, DEFAULT_ERROR} from '../error_handler';
import {ERRORS} from './vualto_errors.js';

const Vualto = {};

Vualto.FAIRPLAY_LA_URL = 'https://fairplay-license.drm.technology/license';
Vualto.FAIRPLAY_CERTIFICATE_URL = 'https://fairplay-license.drm.technology/certificate';
Vualto.PLAYREADY_LA_URL = 'https://playready-license.drm.technology/rightsmanager.asmx';
Vualto.WIDEVINE_LA_URL = 'https://widevine-proxy.drm.technology/proxy';

/**
 * Get a vualto token from the ESB
 * @param sessionToken
 * @param {String} mpxToken - The mpxToken. Example: CoY_YgE6i_Y-uMsSEAqkUVD6MBBQ4HAM
 * @param {String} globalUserId
 * @param {String|Array} releasePids - The release pid from the feed. Example: EuuFsorE2Lzs
 * @param protectionScheme - The DRM type for the token, Example: widevine, fairplay or playready.
 * @param {Function} callback
 * @param {Boolean} callback.success
 * @param {String} callback.token|callback.error
 */
Vualto.getVualtoToken = function(sessionToken, mpxToken, globalUserId, releasePids, protectionScheme, callback) {
    HttpUtils.post({
        uri: `${CONSTANTS.esbUrl}externalAuthorization/drmToken/vualto?globalUserId=${globalUserId}`,
        body: {
            auth: mpxToken,
            releasePids: typeof releasePids === 'string' ? [releasePids] : releasePids,
            protectionScheme: protectionScheme
        },
        headers: {
            'Authorization': 'Bearer ' + sessionToken
        }
    }, function onReply(success, data) {
        if (success && data && data.token) callback(true, data.token);
        else callback(false, data);
    });
};

/**
 * Create drmConfiguration for the specified protectionScheme
 * @param sessionToken
 * @param protectionScheme - The protectionScheme to create the token for. E.g. hls_primetime_vu
 * @param mpxToken - The userToken
 * @param globalUserId - The global userId, usually specified by the feed.
 * @param pid - The PID of this content

 * @param {Function} callback
 * @param {Boolean} callback.success - Whether the request succeeded or not
 * @param {DrmConfiguration} callback.drmConfiguration - The created drmConfiguration
 */
Vualto.createDrmConfiguration = function(sessionToken, protectionScheme, mpxToken, globalUserId, pid, callback) {
    Vualto.getVualtoToken(sessionToken, mpxToken, globalUserId, pid, protectionScheme.split('_')[1], function(success, token) {
        success ?
            callback(true, Vualto.getDrmForType(protectionScheme, token)) :
            callback(false, token);
    });
};

/**
 * Creates a mpx/theplatform/media token for the user session
 * @param {Object} options
 * @param {Object} options.globalUserId
 * @param {Object} options.sessionToken
 * @param {Function} callback
 * @param {Function} callback.success
 * @param {Function} callback.token
 *
 * @throws error if the request fails.
 */
Vualto.getMpxToken = function(options, callback) {
    HttpUtils.get({
        uri: `${CONSTANTS.esbUrl}userAccounts/${options.globalUserId}`,
        headers: {
            'Authorization': `Bearer ${options.sessionToken}`
        },
        returnHeaders: true
    }, (success, reply) => {
        const mpxToken = success && reply && reply.headers && reply.headers['x-peg-media-access-token'];
        mpxToken ?
            callback(true, mpxToken) :
            ErrorHandler.throwError(ERRORS.INVALID_REPLY_ESB, {
                reason: 'Failed HTTP request',
                url: '',
                reply
            });
    });
};

Vualto.getDrmForType = function(drmType, vualtoToken) {
    switch (drmType) {
        case 'hls_primetime_vu':
        case 'hls_primetime_spa':
            return new DrmConfiguration(DrmConfiguration.FAIRPLAY, {
                laUrl: Vualto.FAIRPLAY_CERTIFICATE_URL,
                certificateUrl: Vualto.FAIRPLAY_CERTIFICATE_URL,
                token: vualtoToken
            });
        case 'hls_fairplay_vu':
        case 'hls_fairplay_spa':
            return new DrmConfiguration(DrmConfiguration.FAIRPLAY, {
                laUrl: Vualto.FAIRPLAY_LA_URL,
                certificateUrl: Vualto.FAIRPLAY_CERTIFICATE_URL,
                token: vualtoToken
            });
        case 'dash_playready_vu':
        case 'dash_playready_spa':
            return new DrmConfiguration(DrmConfiguration.PLAYREADY, {
                laUrl: Vualto.PLAYREADY_LA_URL,
                token: vualtoToken,
                kid: vualtoToken
            });
        case 'dash_widevine_vu':
        case 'dash_widevine_spa':
            return new DrmConfiguration(DrmConfiguration.WIDEVINE, {
                laUrl: Vualto.WIDEVINE_LA_URL,
                token: vualtoToken
                // kid: this.kid
            });
        case 'dash_primetime_vu':
        case 'dash_primetime_spa':
            return new DrmConfiguration(DrmConfiguration.PRIMETIME, {
                laUrl: Vualto.WIDEVINE_LA_URL,
                token: vualtoToken
                // kid: this.kid
            });
        default:
            ErrorHandler.throwError(DEFAULT_ERROR, {
                reason: 'No DRM type found',
                expected: 'e.g. dash_widevine_vu',
                actual: drmType
            });
    }
};

module.exports = Vualto;



// WEBPACK FOOTER //
// ./src/modules/vualto/vualto.js